import React, { useContext, useState } from "react";
import ConsolidatedCredit from "./ConsolidatedCredit";
import ConsentConsolidated from "./ConsentConsolidated";
import { sideBarContext } from "../../App";

function Consolidated() {
  const [filter, setFilter] = useState("creditOrder");
  const { expanded } = useContext(sideBarContext);

  const filters = [
    {
      name: "creditOrder",
      title: "Credit Order",
    },
    // {
    //   name: "creditAnalytics",
    //   title: "Credit Analytics",
    // },
    {
      name: "consentSummary",
      title: "Consent Summary",
    },
  ];

  return (
    <div
      className={`${
        expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
      } bg-[#f1f1f6] h-[100vh] px-[16px] pt-[16px] pb-4`}
    >
      <div className=" w-full bg-white h-[57px] rounded-lg p-4">
        <p className=" text-xl font-semibold">Consolidated</p>
      </div>
      <div className=" w-full bg-white px-4 mt-4 pt-[14px] rounded-lg ">
        <p className=" text-base font-bold">All Users</p>
        <div className=" text-sm  space-x-8 mt-1">
          {" "}
          {/* <button
            className={`   ${
              filter === "creditOrder"
                ? "border-b-[3px] border-[#212b36]  font-semibold "
                : ""
            }   py-[12px]`}
            onClick={() => setFilter("creditOrder")}
          >
            Credit Order
          </button> */}
          {filters.map((item, index) => (
            <button
              key={index}
              className={`   ${
                filter === item.name
                  ? "border-b-[3px] border-[#212b36]  font-semibold "
                  : ""
              }   py-[12px]`}
              onClick={() => setFilter(item.name)}
            >
              {item.title}
            </button>
          ))}
        </div>
      </div>

      {filter === "creditOrder" && <ConsolidatedCredit />}
      {/* {filter === "creditAnalytics" && <CreditAnalytics />} */}
      {filter === "consentSummary" && <ConsentConsolidated />}
    </div>
  );
}

export default Consolidated;
